import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { APP } from '../actionTypes/actionTypes';
import { IAppConfiguration } from '../model/store.model';

const initialState: IAppConfiguration = {
    environment: {},
};

const appSlice = createSlice({
    name: APP,
    initialState,
    reducers: {
        setAppInfo: (state, action: PayloadAction<IAppConfiguration>) => {
            const { payload } = action;
            state.environment = { ...payload.environment };
        },
    },
});

export const { setAppInfo } = appSlice.actions;
export default appSlice.reducer;
